import { useQuery } from "@tanstack/react-query";

import { CHANNEL_CACHE_KEYS } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getChannelsMock } from "@/mock/handlers/channel";
import { useGlobalStore } from "@/stores/global";
import { Channel } from "@/types/channel";
import { CursorPaginationResponse } from "@/types/pagination";

import { api } from "@/lib/api-client";

export const useGetAllChannels = (options?: { enabled?: boolean }) => {
  const { activeWorkspaceId } = useGlobalStore();

  return useQuery({
    queryKey: CHANNEL_CACHE_KEYS.list(),
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        return getChannelsMock();
      }

      const channels = await api
        .get("channels?limit=100&page=1")
        .json<CursorPaginationResponse<Channel>>();

      return channels.data.result;
    },
    enabled: (options?.enabled ?? true) && Boolean(activeWorkspaceId),
  });
};
